export default function hasPresetInstructions(oss, dataType) {
  // assesses whether OTLFB survey substance has built-in instructions
  const substancesWithInstructionsBuiltIn = new Set([
    'Alcohol:All Types:Numeric',
    'Alcohol:Liquor:Numeric',
    'Alcohol:Wine:Numeric',
    'Alcohol:Beer:Numeric',
    'Alcohol:All Types:Binary',
    'Alcohol:Liquor:Binary',
    'Alcohol:Wine:Binary',
    'Alcohol:Beer:Binary',
    'Cigarettes:All Types:Numeric',
    'E-Cigarettes:All Types:Binary'
  ])
  const substanceKey = `${oss.substance.name}:${oss.substanceMode.name}:${dataType}`
  return substancesWithInstructionsBuiltIn.has(substanceKey)
}